import { render } from "./PasswordChange.vue?vue&type=template&id=14968c7a&ts=true"
import script from "./PasswordChange.vue?vue&type=script&lang=ts"
export * from "./PasswordChange.vue?vue&type=script&lang=ts"

import "./PasswordChange.vue?vue&type=style&index=0&id=14968c7a&lang=css"

import exportComponent from "/home/quangphuc/s-tech/admin-nhaongay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__